// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".semi-portal{position:absolute;top:0;left:0;width:100%;z-index:1}.semi-portal-inner{position:absolute;background-color:rgba(0,0,0,0);min-width:max-content}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
